'use client';

import { c as _c } from "react/compiler-runtime";
import { useDisclosure } from '@heroui/react';
import { useCallback, useMemo, useState } from 'react';
import ConfirmModal from '@/components/ui/modals/confirm-modal';
import type { ConfirmOptions, ConfirmProviderProps } from '@/components/ui/modals/confirm-modal/interfaces';
import { ConfirmContext } from '@/contexts/confirm-context';
export default function ConfirmProvider(t0) {
  const $ = _c(27);
  const {
    defaultOptions: t1,
    children
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const defaultOptions = t2;
  const {
    isOpen,
    onOpen,
    onClose,
    onOpenChange
  } = useDisclosure();
  const [options, setOptions] = useState(defaultOptions);
  const [resolver, setResolver] = useState(_temp);
  const [inputValue, setInputValue] = useState("");
  let t3;
  if ($[2] !== defaultOptions || $[3] !== onOpen) {
    t3 = options_0 => {
      setOptions({
        ...defaultOptions,
        ...options_0
      });
      onOpen();
      return new Promise(resolve => {
        setResolver(() => resolve);
      });
    };
    $[2] = defaultOptions;
    $[3] = onOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const confirm = t3;
  let t4;
  if ($[5] !== onClose || $[6] !== resolver) {
    t4 = () => {
      setInputValue("");
      onClose();
      resolver(true);
    };
    $[5] = onClose;
    $[6] = resolver;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleConfirm = t4;
  let t5;
  if ($[8] !== onClose || $[9] !== resolver) {
    t5 = () => {
      setInputValue("");
      onClose();
      resolver(false);
    };
    $[8] = onClose;
    $[9] = resolver;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleCancel = t5;
  let t6;
  if ($[11] !== onClose) {
    t6 = () => {
      setInputValue("");
      onClose();
    };
    $[11] = onClose;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleClose = t6;
  let t7;
  if ($[13] !== confirm) {
    t7 = {
      confirm
    };
    $[13] = confirm;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const contextValue = t7;
  let t8;
  if ($[15] !== handleCancel || $[16] !== handleClose || $[17] !== handleConfirm || $[18] !== inputValue || $[19] !== isOpen || $[20] !== onOpenChange || $[21] !== options) {
    t8 = <ConfirmModal isOpen={isOpen} onClose={handleClose} onOpenChange={onOpenChange} config={options} onConfirm={handleConfirm} onCancel={handleCancel} inputValue={inputValue} setInputValue={setInputValue} />;
    $[15] = handleCancel;
    $[16] = handleClose;
    $[17] = handleConfirm;
    $[18] = inputValue;
    $[19] = isOpen;
    $[20] = onOpenChange;
    $[21] = options;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== children || $[24] !== contextValue || $[25] !== t8) {
    t9 = <ConfirmContext.Provider value={contextValue}>{children}{t8}</ConfirmContext.Provider>;
    $[23] = children;
    $[24] = contextValue;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}
function _temp() {}